<script setup lang="ts">
import { provide } from 'vue';
import CheckForm from './CheckForm.vue';
import useAirdropChecker from './useAirdropChecker';
import Results from './Results.vue';

const airdropCheckerData = useAirdropChecker();
provide('useAirdropChecker', airdropCheckerData);
</script>

<template>
  <v-container class="flex flex-col">
    <header class="text-center p-12">
      <h1 class="text-3xl font-extrabold">Airdrop Checker</h1>
      <p class="text-lg">
        Our tool to track your airdrop rewards effortlessly.
      </p>
    </header>

    <CheckForm />
    <Results />
  </v-container>
</template>
